import { getUcpBackendUrl } from '@/lib/ucp/backend-base';

export const getMiddlewareOrigin = (): string => {
  const fromUcp = getUcpBackendUrl();
  if (fromUcp) return fromUcp;
  const m = (process.env.NEXT_PUBLIC_MIDDLEWARE_URL ?? '').replace(/\/$/, '');
  if (m) return m;

  return 'http://localhost:8080';
};
